import React from "react";

import "../App.css";

const About = () => {
  return (
    <div>
      <div className="about">
        <div className="about_historia">
          <h1>Nuestra Historia</h1>
          <img src="/img/about_1.png" alt=""></img>
        </div>
        <p>
          Corner Dog nace en Chile con el objetivo de entregar{" "}
          <b>Snacks 100% naturales</b> a todos los rincones de nuestro país.
          <br />
          <br />
          Somos una empresa que nace por el amor hacia nuestras mascotas, por la
          necesidad de verlos crecer sanos y el deseo de despertar el instinto
          que llevan dentro.
          <br />
          <br />
          <b>
            Líderes de la innovación, seguidores de la compasión, soñadores y
            amantes de la naturaleza.
          </b>{" "}
          Nos caracterizamos por ofrecer productos distintos e innovadores,
          naturales y sabrosos.{" "}
        </p>
      </div>

      <div className="about">
        <div className="about_historia">
          <h1>Que encontrarás aquí</h1>
          <img src="/img/about_2.png" alt=""></img>
        </div>
        <p>
          <b>En nuestra página podrás encontrar Snacks únicos.</b> Muy
          nutritivos, 100% naturales y que ayudan de manera muy eficaz a la
          entretención y la alimentación. Además ofrecemos tips semanales que te
          ayudarán a forjar un vínculo íntimo y saludable con tu mascota.
          <br />
          <br />
          La mayoría de nuestros productos son altos en <b>proteínas</b>, debido
          a la presencia de carne deshidratada, lo que ayuda en la generación de
          músculos y aporta gran cantidad de energía. Además, gracias al alto
          contenido de <b>colágeno</b>, ayudan en el refuerzo de articulaciones,
          la regeneración de la piel y el fortalecimiento de la masa muscular.
          <br />
          <br />
          <b>Son excelentes para dar como premio</b> y poder desarrollar
          habilidades, gestos y enseñanzas. Los huesos ayudan en el{" "}
          <b>
            fortalecimiento de la mandíbula, la liberación de ansiedad y el
            manejo de estrés.
          </b>
          <br />
          <br />
          Nuestros productos vienen de{" "}
          <b>animales criados en la Patagonia Chilena,</b> en un ambiente libre
          y sano. Es por eso que las características nutritivas, los olores y
          los sabores están presentes con mayor intensidad.
        </p>
      </div>

      <div className="about">
        <div className="about_historia">
          <h1>Nuestra Filosofía</h1>
          <img src="/img/about_3.png" alt=""></img>
        </div>
        <p>
          Nuestra frase lo dice todo: <b>Vuelve a lo Natural.</b>
          <br />
          <br />
          Apelamos al sentido común. Creemos que la naturaleza es sabia, por lo
          que solo necesitábamos observarla para determinar la mejor dieta para
          nuestras mascotas.
          <br />
          <br />
          Hemos seleccionado y diseñado nuestros productos pensando siempre en
          nuestros peludos y en el planeta en el que vivimos.
          <br />
          <br />
          Nuestras vidas nos han llevado a ser muy conscientes de la importancia
          de una buena alimentación y del uso de productos de calidad. Por eso
          creemos que <b>nuestras mascotas necesitan Snacks Naturales,</b> no
          basta solo con darles cariño y alimento. Solo así se puede lograr
          despertar el instinto que llevan dentro y lograr el desarrollo
          completo que necesitan.
        </p>
      </div>

      <div className="about">
        <div className="about_historia">
          <h1>Delivery</h1>
          <img src="/img/about_4.png" alt=""></img>
        </div>
        <p>
          Despachamos a todo Chile. En Santiago con medios propios en 3 días hábiles y a Regiones a través de Starken.
          <br />
          <br />
          Si tienes dudas o quieres contactarte con nosotros, escríbenos a{" "}
          <b>hola@cornerdog.cl</b>, por whatsapp al <b>+569 6656 4743</b>{" "}
          o instagram a <b>@corner_ _dog</b>.
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <i>Siempre amantes, siempre atentos.</i>
          <br />
          <br />
          <i>Siempre Corner Dog.</i>
        </p>
      </div>
    </div>
  );
};

export default About;
